import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { RootState } from '@kiosk/common/types/RootState';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
